module.exports = __webpack_public_path__ + "statics/img/cate5-4@2x.eaf0e2e7.png";